import { useRegisterAgentContext } from '@backrs_ui/grow-ui/src/agentContext/useRegisterAgentContext';

export const useAgentContext = (isDirty: boolean) => {
  useRegisterAgentContext({
    kind: 'section',
    title: 'Explore Tradeoffs',
    description:
      'Interactive two-panel view where the user can change quiz answers (left panel) and see how their Career Track, Educational Investments, and Career Path rankings update in real-time (right panel).',
    detail: isDirty
      ? 'The user has modified answers and can lock in their changes.'
      : 'No answers have been modified yet.',
  });
};
